class OddsSaleCountdown extends HTMLElement {
  connectedCallback() {
    this.deadline = Date.parse(this.dataset.deadline || '');

    if (!Number.isFinite(this.deadline)) {
      this.hidden = true;
      return;
    }

    this.parts = {
      days: this.querySelector('[data-countdown-days]'),
      hours: this.querySelector('[data-countdown-hours]'),
      minutes: this.querySelector('[data-countdown-minutes]'),
      seconds: this.querySelector('[data-countdown-seconds]'),
    };

    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  tick() {
    const remaining = this.deadline - Date.now();

    if (remaining <= 0) {
      window.clearInterval(this.interval);
      this.hidden = true;
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.setPart('days', days);
    this.setPart('hours', hours);
    this.setPart('minutes', minutes);
    this.setPart('seconds', seconds);
  }

  setPart(key, value) {
    if (this.parts[key]) this.parts[key].textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('so-sale-countdown')) {
  customElements.define('so-sale-countdown', OddsSaleCountdown);
}
